import { Swiper, Image } from "antd-mobile";
import React from "react";

const HomeSwiper = (props) => {
  const { aliOrWx } = props

  const laimaoImage = 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/laimao.jpg'
  const headImage = 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/create-order-head.png'
  const headImage2 = 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/home_head.png'
  const list = aliOrWx == 'wechat' ? [laimaoImage, laimaoImage] : [headImage, headImage2];

  return (
    <Swiper loop={true} autoplay={true}>
      {
        // TODO: 根据实际情况获取轮播图实际URL
        list.map((element, index) => (
          <Swiper.Item key={index}>
            <Image src={element} />
          </Swiper.Item >
        ))
      }
    </Swiper>
  )
}

export default HomeSwiper